import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import SvgIcon from '../../../common/base/SvgIcon.vue';
import ScreenSharingIcon from '../../../common/icons/ScreenSharingIcon.vue';
import TuiButton from '../../../common/base/Button.vue';
import Dialog from '../../../common/base/Dialog';
import eventBus from '../../../../hooks/useMitt';
import { useI18n } from '../../../../locales';
interface Props {
  isMiniRegion: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isMiniRegion: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();
const showStopShareRegion = ref(false);



function openStopConfirmDialog() {
  showStopShareRegion.value = true;
}

function stopScreenSharing() {
  showStopShareRegion.value = false;
  eventBus.emit('ScreenShare:stopScreenShare');
}

return { __sfc: true,t, showStopShareRegion, openStopConfirmDialog, stopScreenSharing, SvgIcon, ScreenSharingIcon, TuiButton, Dialog }
}

})